import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: 'product-not-found',
    loadComponent: async () => import('./product-not-found/product-not-found.component').then(m => m.ProductNotFoundComponent)
  },
  {
    path: ':name',
    loadComponent: async () => import('./product/product.component').then(m => m.ProductComponent)
  },
  {
    path: ':name/:variantId',
    loadComponent: async () => import('./variant/variant.component').then(m => m.VariantComponent)
  },
  {
    path: '',
    redirectTo: 'product-not-found',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule { }
